import { render, staticRenderFns } from "./SubmitResult.vue?vue&type=template&id=ac9d9e58&scoped=true&"
import script from "./SubmitResult.vue?vue&type=script&lang=js&"
export * from "./SubmitResult.vue?vue&type=script&lang=js&"
import style0 from "./SubmitResult.vue?vue&type=style&index=0&id=ac9d9e58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac9d9e58",
  null
  
)

export default component.exports